export const DEACTIVATE_TITLE = "Desativar usuário";
export const ACTIVATE_TITLE = "Ativar usuário";

export const DEACTIVATE_SUBTITLE = "Essa ação desativa o acesso do usuário ao Hub.";
export const ACTIVATE_SUBTITLE = "Essa ação ativa o acesso do usuário ao Hub.";

/** MS001 — alerta do impacto da inativação, apresentado antes da confirmação. */
export const DEACTIVATE_MESSAGE =
  "Este usuário perderá o acesso ao Hub e suas pendências não serão tratadas. O gerente deve reatribuir as responsabilidades dele a outro usuário.";

/** MS002 — informativo do efeito da ativação, apresentado antes da confirmação. */
export const ACTIVATE_MESSAGE =
  "O acesso do usuário será restaurado e ele poderá acessar novamente o Hub e gerenciar suas pedências e responsabilidades.";

export const DEACTIVATE_CONFIRM_LABEL = "Desativar Usuário";
export const ACTIVATE_CONFIRM_LABEL = "Ativar Usuário";
